export const CIME_DOSSIER_FILE_DRAG = 'application/x-cime-dossier-file';

export type InternalFileDragPayload = {
  fileId: string;
  fromFolderId: string | null;
};

export function serializeInternalFileDrag(payload: InternalFileDragPayload): string {
  return JSON.stringify({
    v: 1,
    fileId: payload.fileId,
    fromFolderId: payload.fromFolderId,
  });
}

export function parseInternalFileDrag(raw: string | null | undefined): InternalFileDragPayload | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as { v?: number; fileId?: unknown; fromFolderId?: unknown };
    if (parsed.v !== 1 || typeof parsed.fileId !== 'string' || parsed.fileId.length === 0) {
      return null;
    }
    if (parsed.fromFolderId !== null && typeof parsed.fromFolderId !== 'string') {
      return null;
    }
    return {
      fileId: parsed.fileId,
      fromFolderId: parsed.fromFolderId,
    };
  } catch {
    return null;
  }
}

export function shouldMoveFile(fromFolderId: string | null, toFolderId: string | null): boolean {
  return fromFolderId !== toFolderId;
}

export const CIME_DOSSIER_FILE_DRAG_ALT = 'text/x-cime-dossier-file';

export function dropIsInternalFile(types: readonly string[]): boolean {
  const lower = types.map((t) => t.toLowerCase());
  return lower.includes(CIME_DOSSIER_FILE_DRAG) || lower.includes(CIME_DOSSIER_FILE_DRAG_ALT);
}

export function dropContainsOsFiles(types: readonly string[]): boolean {
  if (dropIsInternalFile(types)) return false;
  return types.includes('Files') || types.includes('application/x-moz-file');
}
